import { toSearchQueryString } from '../../utils/request-url-helper';
export const SearchMediaApiPath = '/search/media';
export const searchMedia = async (axios, query, vector) => {
  const requestUrl = `${SearchMediaApiPath}${toSearchQueryString({
    ...query,
    vector
  })}`;
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};
export const hasActiveFilters = query => query.topics?.length !== 0 || query.shows?.length !== 0 || query.mediaProperties && query.mediaProperties.length > 0 || !!query.from || !!query.to;